import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {Switch, withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Notifications from 'react-notification-system-redux';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css'
import './assets/css/adminlte.css';
import './assets/css/skin-custom.css';
import './assets/css/styles.css';
import 'slimscroll';
import 'fastclick';
import ScrollToTop from './common/components/ScrollToTop';
import PublicRoute from './common/components/PublicRoute';
import PrivateRoute from './common/components/PrivateRoute';
import {initializeLanguage} from './common/redux/localeReducer';
import {Narrow, FullWidth} from './common/layouts';

const notificationStyle = {
	Containers: {
		tc: {
			fontSize: '30px'
		}
	},
	ActionWrapper: {
		DefaultStyle: {
			textAlign: 'center'
		}
	}
};

class App extends Component {
	componentWillMount() {
		const {initializeLanguage} = this.props;
		initializeLanguage();
	}

	render() {
		const {pageTitle, notification} = this.props;
		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<Notifications notifications={notification} style={notificationStyle}/>
				<ScrollToTop>
					<Switch>
						<PublicRoute path="/auth" component={Narrow}/>
						<PrivateRoute path="/" component={FullWidth}/>
					</Switch>
				</ScrollToTop>
			</Fragment>
		)
	}
}

App.defaultProps = {
	pageTitle: 'CRIS 3.0'
};

App.propTypes = {
	pageTitle: PropTypes.string,
	notification: PropTypes.array
};

const mapStateToProps = state => ({
	notification: state.notification
});

const mapDispatchToProps = dispatch => bindActionCreators({
	initializeLanguage
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
